const SEND_OTP_API = 'lifeline_apis/auth/send_otp';
const SUBMIT_OTP_API = 'lifeline_apis/auth/submit_otp';
const SUBMIT_TOTP_API = 'lifeline_apis/auth/submit_totp';
const GOOGLE_LOGIN = '/api/crm_proxy/lifeline_apis/auth/login';

const ERROR_GMAIL_DOMAIN =
  'domain gmail.com does not have the permission to login';
const ERROR_ACCOUNT_NOT_FOUND = "we couldn't find an account";
const ERROR_ACCOUNT_BLOCKED = 'account has been blocked';

export {
  SEND_OTP_API,
  SUBMIT_OTP_API,
  SUBMIT_TOTP_API,
  GOOGLE_LOGIN,
  ERROR_GMAIL_DOMAIN,
  ERROR_ACCOUNT_NOT_FOUND,
  ERROR_ACCOUNT_BLOCKED,
};
